import LeakRulesIndex from '@/views/LeakRulesIndex.vue';
import LeakRulesCreate from '@/views/LeakRulesCreate.vue';

const routes = [
    {
        path: '/leak-rules',
        name: 'LeakRulesIndex',
        component: LeakRulesIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/leak-rules/create',
        name: 'LeakRulesCreate',
        component: LeakRulesCreate,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
